import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../About.css';

const Manufacturing = () => {
  const solutions = ['Production Planning', 'Quality Control Systems', 'Supply Chain Optimization', 'IoT Integration', 'Predictive Maintenance', 'Inventory Management'];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Manufacturing Solutions</h1>
          <p>IoT integration, supply chain optimization, and smart factory solutions</p>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Smart Manufacturing</h2>
            <p>
              We help manufacturers implement Industry 4.0 technologies including IoT sensors, predictive
              maintenance, and real-time production monitoring. Our solutions integrate with existing
              equipment and provide actionable insights for continuous improvement.
            </p>
          </div>
        </div>
      </section>

      <section className="about-expertise">
        <div className="container">
          <div className="section-header"><h2>Manufacturing Solutions</h2></div>
          <div className="expertise-grid">
            {solutions.map((s, i) => <div key={i} className="expertise-item">{s}</div>)}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Modernize Your Manufacturing</h2>
            <p>Let's discuss your smart factory initiatives.</p>
            <Link to="/contact">
              <Button variant="contained" size="large" endIcon={<ArrowForwardIcon />}
                sx={{ backgroundColor: '#2271b1', color: '#ffffff', fontWeight: '600', padding: '14px 32px', fontSize: '15px', textTransform: 'none', borderRadius: '3px', boxShadow: '0 1px 0 #135e96', '&:hover': { backgroundColor: '#135e96' } }}>
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Manufacturing;
